export enum COLLAPSE_STYLES {
    TEXT,
    CONTAINED,
}
